module.exports = __webpack_public_path__ + "img/login-bg.b00fdc6b.jpg";